export const faqs = [
  {
    q: '¿Cómo recibo el material?',
    a: 'El acceso es inmediato apenas terminás la compra. Te llega un mail con los enlaces para descargar todo el material digital en tu dispositivo.',
  },
  {
    q: '¿Sirve si soy profe principiante?',
    a: '¡Totalmente! El kit está pensado para guiarte paso a paso. Incluye cues verbales, temas filosóficos y secuencias lógicas que te van a dar mucha seguridad al enseñar.',
  },
  {
    q: '¿Para qué estilos de yoga sirve?',
    a: 'Las clases están armadas principalmente para Hatha y Vinyasa, pero las adaptás fácil a otros estilos dinámicos o restaurativos.',
  },
  {
    q: '¿Cómo pago los $19.990?',
    a: 'El precio está en pesos argentinos y es final. Pagás con tarjeta de débito o crédito, o con Mercado Pago, y podés hacerlo hasta en 3 cuotas sin interés.',
  },
  {
    q: '¿Los bonos están incluidos en el precio?',
    a: 'Sí, los 5 bonos exclusivos vienen incluidos 100% gratis con tu compra de hoy.',
  },
  {
    q: '¿En qué formato están los archivos?',
    a: 'Todo el material se entrega en PDF de alta calidad, optimizado para leer en el celu, en la tablet o para imprimir si preferís.',
  },
  {
    q: '¿Tengo que pagar una mensualidad?',
    a: 'No. Son $19.990 una sola vez y tenés acceso de por vida a todo el material y a sus futuras actualizaciones.',
  },
  {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tenés 7 días de garantía. Si sentís que el kit no es para vos, nos escribís un mail y te devolvemos el 100% de tu plata sin hacerte preguntas.',
  },
]
